import './MobileMenu.css';
export var backButton = '_1y10jf2-3-12-1';
export var body = '_1y10jf7-3-12-1';
export var bodyAnimatedBack = '_1y10jf9-3-12-1';
export var bodyAnimatedForward = '_1y10jf8-3-12-1';
export var header = '_1y10jf1-3-12-1';
export var headerTitleText = '_1y10jf4-3-12-1';
export var headerTitleWrapper = '_1y10jf3-3-12-1';
export var panel = '_1y10jf0-3-12-1';